import type { QuoteViewMode, RequestTabId } from '../types'

export type OrderViewState = {
  tab: RequestTabId
  quoteViewMode: QuoteViewMode
}

const TAB_TO_SEGMENT: Record<RequestTabId, string> = {
  explore: 'explore',
  checkout: 'checkout',
  delivery: 'delivery',
}

export const encodeOrderView = (
  tab: RequestTabId,
  quoteViewMode: QuoteViewMode = 'canvas'
): string => {
  const segment = TAB_TO_SEGMENT[tab]
  if (tab === 'explore' && quoteViewMode === 'document') {
    return `${segment}:document`
  }
  return segment
}

export const parseOrderView = (
  view: string | null | undefined
): OrderViewState | null => {
  if (!view) return null

  const [tabPart, modePart] = view.split(':')

  // Legacy URLs → new tabs
  if (tabPart === 'billing') {
    if (modePart === 'invoice') {
      return { tab: 'delivery', quoteViewMode: 'canvas' }
    }
    return { tab: 'checkout', quoteViewMode: 'canvas' }
  }
  if (tabPart === 'quote' && modePart === 'document') {
    return { tab: 'checkout', quoteViewMode: 'canvas' }
  }
  if (
    tabPart === 'canvas' ||
    tabPart === 'sizes' ||
    tabPart === 'quote'
  ) {
    return { tab: 'explore', quoteViewMode: 'canvas' }
  }
  if (tabPart === 'proofs') {
    return { tab: 'checkout', quoteViewMode: 'canvas' }
  }
  if (tabPart === 'summary' || tabPart === 'shipping') {
    return { tab: 'delivery', quoteViewMode: 'canvas' }
  }

  const tab = SEGMENT_TO_TAB[tabPart]
  if (!tab) return null

  const quoteViewMode: QuoteViewMode =
    tab === 'explore' && modePart === 'document' ? 'document' : 'canvas'

  return { tab, quoteViewMode }
}

const SEGMENT_TO_TAB: Record<string, RequestTabId> = {
  explore: 'explore',
  checkout: 'checkout',
  delivery: 'delivery',
}

export const buildOrderViewPath = (
  basePath: string,
  publicId: string,
  tab: RequestTabId,
  quoteViewMode: QuoteViewMode = 'canvas'
) => `${basePath}/${publicId}/${encodeOrderView(tab, quoteViewMode)}`
